export class NgoSocialMediaModel {
  facebook: string = null;
  twitter: string = null;
  youtube: string = null;
  linkedin: string = null;

  constructor(text?: string) {
    console.log(text);
    if (text) {
      const obj = JSON.parse(text);
      Object.keys(this).forEach((key) => {
        if (obj.hasOwnProperty(key)) {
          this[key] = obj[key];
        }
      });
    }
  }
}
